import React from 'react';
import PropTypes from 'prop-types';
import { TRANSLATE_PREFIX } from '../../consts';
import DeleteIcon from '../DeleteIcon';
import css from './SingularMacroCell.css';

const TAB_PREFIX = `${TRANSLATE_PREFIX}.POSTBACK_TEMPLATES_TAB`;

const SingularMacroCell = ({ row, onRemove, readOnly }) => (
    <td className={css.cell}>
        <div className={css.macroCell}>
            {!readOnly && !row.isRequired && (
                <DeleteIcon
                    className={css.deleteBtn}
                    confirmTitleKey={`${TAB_PREFIX}.CONFIRM_DIALOG.REMOVE_TEMPLATE_MACRO_TITLE`}
                    confirmTextKey={`${TAB_PREFIX}.CONFIRM_DIALOG.REMOVE_TEMPLATE_MACRO_TEXT`}
                    shouldConfirm={!!(row.partner_parameter_key || '').trim()}
                    onConfirm={() => onRemove(row.singular_macro)}
                />
            )}
            <div className={css.macroRow}>
                <code className={css.macroCode}>{row.singular_macro}</code>
                {row.isRequired && !readOnly && <span className={css.required}>*</span>}
            </div>
        </div>
    </td>
);

SingularMacroCell.propTypes = {
    row: PropTypes.shape({
        singular_macro: PropTypes.string.isRequired,
        partner_parameter_key: PropTypes.string,
        isRequired: PropTypes.bool,
    }).isRequired,
    onRemove: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
};

export default SingularMacroCell;
